import { LayoutComponent } from '../layout/layout.component';
import { AuthGuard } from '../shared/services/authguard.service';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { ConfirmEmailComponent } from './pages/register/confirmemail.component';
import { RecoverComponent } from './pages/recover/recover.component';
import { LockComponent } from './pages/lock/lock.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { Error404Component } from './pages/error404/error404.component';
import { Error500Component } from './pages/error500/error500.component';
import { ResetPasswordComponent } from './pages/recover/resetpassword.component';

export const routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            { path: '', redirectTo: 'home', canActivate: [AuthGuard], pathMatch: 'full' },
            { path: 'home', canActivate: [AuthGuard], loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\home\\home.module')['HomeModule']);  });}) },
            { path: 'client', canActivate: [AuthGuard], loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\client\\client.module')['ClientModule']);  });}) },
            { path: 'survey', canActivate: [AuthGuard], loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\survey\\survey.module')['SurveyModule']);  });}) },
            { path: 'user', canActivate: [AuthGuard], loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\user\\user.module')['UserModule']);  });}) },
            { path: 'group', canActivate: [AuthGuard], loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\group\\group.module')['GroupModule']);  });}) },
            { path: 'consultation', canActivate: [AuthGuard], loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\consultation\\consultation.module')['ConsultationModule']);  });}) },
            { path: 'settings', canActivate: [AuthGuard], loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\settings\\settings.module')['SettingsModule']);  });}) }           
        ]
    },

    // Not lazy-loaded routes
    { path: 'login', component: LoginComponent },    
    { path: 'register', component: RegisterComponent },
    { path: 'confirmemail/:id/:confirmationCode', component: ConfirmEmailComponent },
    { path: 'recover', component: RecoverComponent },
    { path: 'lock', component: LockComponent },
    { path: 'maintenance', component: MaintenanceComponent },
    { path: '404', component: Error404Component },
    { path: '500', component: Error500Component },
    { path: 'userresetpassword/:id/:resetCode', component: ResetPasswordComponent },

    // Not found
    { path: '**', redirectTo: 'home' }

];



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/routes/routes.ts